import { Text } from "../../UILib";

export default function BiFooter() {
  return (
    <Text type="p1" align="left">
      For Internal Use Only (Aug 2021) PC-US-122807
    </Text>
  );
}
